import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data41 from '../../data/data41.json'
import ArticleList from '../../Components/ArticleList';

const BoardMaterials: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>理事会资料</h1>
                <ArticleList dataId="41" data={data41 as any} />
            </div>
        } />
    );
};

export default BoardMaterials;